import { createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { actionAccountCheckAuth, actionAccountGetUser, actionAccountLogout } from 'store/auth/actions';
import { ICurrentUserProfileResponse } from '__generated__/api';
import { NAMESPACE } from './helpers';
import { AuthStatus } from 'services/auth';


interface InitState {
  isInit: boolean;
  isLoading: boolean;
  error: null | SerializedError;
  user: null | ICurrentUserProfileResponse;
  languageID: null | string;
}

const initStateAccount = (): InitState => {
  return {
    isInit: false,
    isLoading: false,
    error: null,
    user: null,
    languageID: null,
  };
};

const slice = createSlice({
  name: NAMESPACE,
  initialState: initStateAccount(),
  reducers: {
    actionAccountSetLanguageID(state, action: PayloadAction<string | null>) {
      state.languageID = action.payload;
    },
    actionAccountClear() {
      return initStateAccount();
    },
    actionAccountRefresh() {},
  },
  extraReducers: (builder) => {
    builder.addCase(actionAccountGetUser.pending, (state, action) => {
      const { isOnTheBackground } = action.meta.arg;
      if (!isOnTheBackground) {
        state.isLoading = true;
      }
      state.error = null;
    });
    builder.addCase(actionAccountGetUser.fulfilled, (state, action) => {
      const user = action.payload;

      const { isOnTheBackground } = action.meta.arg;

      if (!isOnTheBackground) {
        state.isLoading = false;
      }

      state.isInit = true;
      state.user = user;
    });
    builder.addCase(actionAccountGetUser.rejected, (state, action) => {
      const { error } = action;
      const { isOnTheBackground } = action.meta.arg;
      if (!isOnTheBackground) {
        state.isLoading = false;
      }
      state.error = error;
      state.isInit = true;
    });

    builder
    .addCase(actionAccountCheckAuth.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(actionAccountCheckAuth.fulfilled, (state, action) => {
      state.isInit = true;
      state.isLoading = false;

      if (action.payload === AuthStatus.ERROR) {
        state.languageID = null;
      }
    })
    .addCase(actionAccountCheckAuth.rejected, (state, action) => {
      if (action.error.name === 'AbortError') return state;

      state.isInit = true;
      state.isLoading = false;
    });

    builder.addCase(actionAccountLogout.fulfilled, () => {
      return initStateAccount();
    });
  },
});
export const { actionAccountClear, actionAccountSetLanguageID, actionAccountRefresh } =
  slice.actions;
export const reducerAccount = slice.reducer;
